import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
var shouldForwardProp = function shouldForwardProp(prop) {
  switch (prop) {
    // Add any props here that should not be forwarded to the underlying DOM element.
    case "color":
      return false;
    default:
      return true;
  }
};
export var ArrowsStyled = styled("svg", {
  shouldForwardProp: shouldForwardProp
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    color: ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
//# sourceMappingURL=ArrowsStyled.js.map